// extracted by mini-css-extract-plugin
export var grid = "_z-0";
export var span1 = "_z-2";
export var span10 = "_z-b";
export var span10L = "_z-z";
export var span10M = "_z-n";
export var span10Xl = "_z-1b";
export var span11 = "_z-c";
export var span11L = "_z-10";
export var span11M = "_z-o";
export var span11Xl = "_z-1c";
export var span12 = "_z-d";
export var span12L = "_z-11";
export var span12M = "_z-p";
export var span12Xl = "_z-1d";
export var span1L = "_z-q";
export var span1M = "_z-e";
export var span1Xl = "_z-12";
export var span2 = "_z-3";
export var span2L = "_z-r";
export var span2M = "_z-f";
export var span2Xl = "_z-13";
export var span3 = "_z-4";
export var span3L = "_z-s";
export var span3M = "_z-g";
export var span3Xl = "_z-14";
export var span4 = "_z-5";
export var span4L = "_z-t";
export var span4M = "_z-h";
export var span4Xl = "_z-15";
export var span5 = "_z-6";
export var span5L = "_z-u";
export var span5M = "_z-i";
export var span5Xl = "_z-16";
export var span6 = "_z-7";
export var span6L = "_z-v";
export var span6M = "_z-j";
export var span6Xl = "_z-17";
export var span7 = "_z-8";
export var span7L = "_z-w";
export var span7M = "_z-k";
export var span7Xl = "_z-18";
export var span8 = "_z-9";
export var span8L = "_z-x";
export var span8M = "_z-l";
export var span8Xl = "_z-19";
export var span9 = "_z-a";
export var span9L = "_z-y";
export var span9M = "_z-m";
export var span9Xl = "_z-1a";
export var stretch = "_z-1";